import React from 'react';
import { PersonCrossIcon } from '@navikt/aksel-icons';
import { ContainerCard } from '../ContainerCard';
import { Paragraph } from '../Paragraph';
import { Button } from '../Button';
import { DistributionChannel, TeamLeader } from '../../api/queries';
import classes from './DeleteDistributionChannelDialog.module.css';
import { useTranslation } from 'react-i18next';

type DeleteDistributionChannelDialogProps = {
  channelToDelete: DistributionChannel | null;
  setChannelToDelete: React.Dispatch<
    React.SetStateAction<DistributionChannel | null>
  >;
  onDeleteDistributionChannel: (channel: DistributionChannel) => void;
};

export const DeleteDistributionChannelDialog = ({
  channelToDelete,
  setChannelToDelete,
  onDeleteDistributionChannel,
}: DeleteDistributionChannelDialogProps) => {
  const { t } = useTranslation();

  return (
    <ContainerCard className={classes.container}>
      <ContainerCard.Title
        icon={<PersonCrossIcon aria-hidden="true" fontSize="1.5rem" />}
      >
        {t('integrations.deleteDialog.title')}
      </ContainerCard.Title>
      <ContainerCard.Body className={classes.deleteUserBody}>
        <Paragraph size="lg">
          {t('integrations.deleteDialog.description')}
        </Paragraph>
        <div className={classes.buttonContainer}>
          <Button
            variant="danger"
            size="medium"
            disabled={!channelToDelete}
            onClick={() =>
              onDeleteDistributionChannel(
                channelToDelete as DistributionChannel,
              )
            }
          >
            {t('integrations.deleteDialog.deleteButton')}
          </Button>
          <Button
            variant="secondary"
            size="medium"
            onClick={() => setChannelToDelete(null)}
          >
            {t('integrations.deleteDialog.cancelButton')}
          </Button>
        </div>
      </ContainerCard.Body>
    </ContainerCard>
  );
};
